import React from "react";
import { NavLink } from "react-router-dom";

import {
	IcCalendarBlack,
	IcCarSettingGPS,
	IcCarSettingImg,
	IcCarSettingInfo,
	IcCarSettingPaper,
	IcCarSettingTrips,
	IcCarSettingPrice,
	IcExtraFee,
	IcCarSettingTime,
	IcCarSettingDelivey,
	IcListAddress,
	IcCarSD,
	IcWD,
} from "../common/svg";

export default class CarSettingSidebarMobile extends React.Component {
	constructor(props) {
		super(props);
	}

	toggleSdSetting = () => {
		this.closeWdSetting();
		this.props.toggleSdSetting();
	};
	toggleWdSetting = () => {
		this.closeSdSetting();
		this.props.toggleWdSetting();
	};
	closeSdSetting = () => {
		this.props.closeSdSetting();
	};
	closeWdSetting = () => {
		this.props.closeWdSetting();
	};

	render() {
		const { car, handler, carId, isShowMenuSd, isShowMenuWd, reddot } = this.props;

		return (
			<div className="sidebar-settings show-on-med-and-down">
				<ul>
					<li>
						<NavLink className={handler === "#infosetting" ? "active" : ""} to={`/carsetting/${carId}#infosetting`}>
							<IcCarSettingInfo />
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#photossetting" ? "active" : ""} to={`/carsetting/${carId}#photossetting`}>
							<IcCarSettingImg />
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#paperssetting" ? "active" : ""} to={`/carsetting/${carId}#paperssetting`}>
							<IcCarSettingPaper />
							{reddot && <span className="has-reddot"></span>}
						</NavLink>
					</li>

					<li>
						<NavLink className={handler === "#gpssetting" ? "active" : ""} to={`/carsetting/${carId}#gpssetting`}>
							<IcCarSettingGPS />
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#tripssetting" ? "active" : ""} to={`/carsetting/${carId}#tripssetting`}>
							<IcCarSettingTrips />
						</NavLink>
					</li>
					{car.sd === 1 && (
						<li>
							<div className={`sd-settings ${isShowMenuSd ? "open" : ""}`} onClick={this.toggleSdSetting}>
								<IcCarSD />
								{isShowMenuSd && <div onClick={this.closeSdSetting} className="bg-overlay dropdown" />}
								{isShowMenuSd && (
									<div className="dropdown-menu" style={{ transition: ".3s ease all" }} onClick={this.toggleSdSetting}>
										{car.sd === 1 && car.timeApprovedSD === 0 && (
											<span className="status">
												<span className="status orange-dot"></span>Đang chờ duyệt
											</span>
										)}
										<ul className="sub-menu flex-column">
											<li>
												<NavLink
													className={handler === "#pricesetting" ? "active" : ""}
													to={`/carsetting/${carId}#pricesetting`}>
													<IcCarSettingPrice /> Giá cho thuê
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#calendarsetting" ? "active" : ""}
													to={`/carsetting/${carId}#calendarsetting`}>
													<IcCalendarBlack /> Lịch xe
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#rentingtimesetting" ? "active" : ""}
													to={`/carsetting/${carId}#rentingtimesetting`}>
													<IcCarSettingTime /> Thiết lập thời gian cho thuê
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#deliverysetting" ? "active" : ""}
													to={`/carsetting/${carId}#deliverysetting`}>
													<IcCarSettingDelivey /> Giao xe tận nơi
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#extrafee" ? "active" : ""}
													to={`/carsetting/${carId}#extrafee`}>
													<IcExtraFee /> Phụ phí
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#policiessetting" ? "active" : ""}
													to={`/carsetting/${carId}#policiessetting`}>
													<IcListAddress /> Thủ tục cho thuê
												</NavLink>
											</li>
										</ul>
									</div>
								)}
							</div>
						</li>
					)}
					{car.wd === 1 && (
						<li>
							<div className={`wd-settings ${isShowMenuWd ? "open" : ""}`} onClick={this.toggleWdSetting}>
								<IcWD />
								{isShowMenuWd && <div onClick={this.closeWdSetting} className="bg-overlay dropdown" />}
								{isShowMenuWd && (
									<div className="dropdown-menu" style={{ transition: ".3s ease all" }} onClick={this.toggleWdSetting}>
										{car.wd === 1 && car.timeApprovedWD === 0 && (
											<span className="status">
												<span className="status orange-dot"></span>Đang chờ duyệt
											</span>
										)}
										<ul className="sub-menu flex-column">
											<li>
												<NavLink
													className={handler === "#wdpricesetting" ? "active" : ""}
													to={`/carsetting/${carId}#wdpricesetting`}>
													<IcCarSettingPrice /> Giá cho thuê
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#wdcalendarsetting" ? "active" : ""}
													to={`/carsetting/${carId}#wdcalendarsetting`}>
													<IcCalendarBlack /> Lịch xe
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#wdrentingtimesetting" ? "active" : ""}
													to={`/carsetting/${carId}#wdrentingtimesetting`}>
													<IcCarSettingTime /> Thiết lập thời gian cho thuê
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#wddeliverysetting" ? "active" : ""}
													to={`/carsetting/${carId}#wddeliverysetting`}>
													<IcCarSettingDelivey /> Đưa đón tận nơi
												</NavLink>
											</li>
											<li>
												<NavLink
													className={handler === "#wdpoliciessetting" ? "active" : ""}
													to={`/carsetting/${carId}#wdpoliciessetting`}>
													<IcListAddress /> Thủ tục cho thuê
												</NavLink>
											</li>
										</ul>
									</div>
								)}
							</div>
						</li>
					)}
				</ul>
			</div>
		);
	}
}
